<template>
  <div class="page-loader">
    <div class="page-loader-wrapper">
      <img src="../assets/images/loader.svg" alt="">
    </div>
  </div>
</template>

<script>
    export default {
        name: "PageLoader"
    }
</script>

<style lang="scss">
  .page-loader {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
    background-color: #fff;

    &-wrapper {
      text-align: center;
      margin-top: 26vh;

      img {
        width: 5rem;
      }
    }
  }
</style>
